import styled from 'styled-components';
import { Button } from 'src/common/components/Button';
import { colors } from 'src/config/colors';

export const LayoutMenuLink = styled(Button)`
  color: ${colors.blue};
`;
